<template>
  <section class="section-block">
    <!-- v-if, if header is not needed do not print it -->
    <div v-if="header" class="section-block__top">
      <h2 class="section-block__header">
        {{ header }}
      </h2>
    </div>

    <div class="grid grid--three">
      <oie-static-article-card
        v-for="news of newsCards"
        :key="news.id"
        :image="news.image"
        :title="news.title"
        :date="news.date"
        :text="news.text"></oie-static-article-card>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    newsCards: {
      type: Array,
      required: true
    },
    header: {
      type: String,
      required: true,
      default: ''
    }
  }
}
</script>
